import React from 'react';

type Props = {
  name?: string;
};

function LibItemOperator({ name }: Props) {
  if (!name) return null;
  return (
    <div
      className="mr-20 max-w-[130px] shrink-0 truncate text-black-gray"
      title={name}
    >
      {`归属人：${name}`}
    </div>
  );
}

export default LibItemOperator;
